/**
 * Whether the manual work queue is on offer in this build. It is not.
 *
 * WHY IT IS OFF. The work queue is the hand-execution path. A campaign step on
 * a channel with no API becomes a card, and a person performs it on a phone and
 * says what happened. That is a fallback for an account with no Device Engine
 * behind it, not a feature, so a campaign action arriving there is a fault
 * report: the engine did not take the step. Carrying the queue in the sidebar
 * beside the inbox and approvals said the opposite. It made hand-sending look
 * like an ordinary part of the day and invited somebody to work the cards
 * instead of asking why they exist.
 *
 * WHAT THIS HIDES. The sidebar row, and the two panels on the dashboard that
 * report cards. `useOpenCards` is disabled while it is off, so the console asks
 * for no list that nothing draws, and the sidebar badge that read the same
 * total goes with the row.
 *
 * NOT THE SHORTCUTS DRAWER, which was tried and reverted. That panel is held to
 * registry parity by its own tests: every declared key reaches it, and each row
 * prints what it needs first. The queue's six keys already say they need an open
 * card, and they still work on `/queue`, so dropping the group would have bought
 * a little tidiness by putting a hole in a guard that stops keys and captions
 * drifting apart. Not a trade worth making for a "for now".
 *
 * WHAT IT DOES NOT TOUCH. Nothing on the server. `linkedin-stub` still writes a
 * card in `manual_card` mode, the `/cards` routes still answer, and `/queue` is
 * still mounted, so a card that does get written is reachable by URL and is not
 * stranded behind a nav row that went away. Hiding a queue is not the same as
 * closing it, and closing it would strand the reservation each card holds.
 *
 * WHAT WAS TRUE WHEN IT WENT OFF, checked against production on 2026-09-24: no
 * `action` card had ever been written. Every card on record was an inbox or a
 * connections sweep, all of them expired or skipped, the newest 2026-09-21, and
 * none open. So this hid nothing anybody was using.
 *
 * ONE CONSTANT, not a row deleted out of four files, because "for now" is the
 * whole point and the way back has to be one edit. Typed `boolean` rather than
 * left as the literal, so the branches it guards stay live code to the compiler
 * and cannot rot while it is off.
 */
export const MANUAL_QUEUE_VISIBLE: boolean = false
